import { api } from '../../lib/api';

export const ADJUSTMENT_STATUSES = [
  { value: 'Draft', label: 'Draft', tone: 'neutral' },
  { value: 'Posted', label: 'Posted', tone: 'success' },
  { value: 'Cancelled', label: 'Cancelled', tone: 'danger' },
];

export const ADJUSTMENT_KINDS = [
  { value: 'WriteOff', label: 'Waste / write-off', tone: 'danger' },
  { value: 'Issue', label: 'Issue / consumption', tone: 'warning' },
  { value: 'Correction', label: 'Correction', tone: 'brand' },
];

export const ADJUSTMENT_REASONS = [
  { value: 'Waste', label: 'Waste' },
  { value: 'Spoilage', label: 'Spoilage' },
  { value: 'Damaged', label: 'Damaged' },
  { value: 'Expired', label: 'Expired' },
  { value: 'Breakage', label: 'Breakage' },
  { value: 'Theft', label: 'Theft / loss' },
  { value: 'Consumption', label: 'Consumption' },
  { value: 'CountCorrection', label: 'Count correction' },
  { value: 'Other', label: 'Other' },
];

export const adjustmentStatusMeta = (status) =>
  ADJUSTMENT_STATUSES.find((s) => s.value === status) || { value: status, label: status, tone: 'neutral' };

export const adjustmentKindMeta = (kind) =>
  ADJUSTMENT_KINDS.find((k) => k.value === kind) || { value: kind, label: kind, tone: 'neutral' };

export const adjustmentReasonLabel = (reason) =>
  ADJUSTMENT_REASONS.find((r) => r.value === reason)?.label || (reason === 'None' ? '—' : reason);

function toQuery(params) {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') q.append(k, v);
  });
  const s = q.toString();
  return s ? `?${s}` : '';
}

export const adjustmentsApi = {
  list: (params = {}) => api.get(`/stock-adjustments${toQuery(params)}`),
  get: (id) => api.get(`/stock-adjustments/${id}`),
  // payload.post === true commits immediately; false saves a draft (e.g. to attach photos first).
  create: (payload) => api.post('/stock-adjustments', payload),
  post: (id) => api.post(`/stock-adjustments/${id}/post`),
  cancel: (id, reason) => api.post(`/stock-adjustments/${id}/cancel`, { reason: reason || null }),
};
